import { Component, Input, Output, OnInit, OnChanges, AfterViewChecked, AfterViewInit, AfterContentInit, EventEmitter, Inject, ElementRef, SimpleChanges } from '@angular/core';
import { WorkflowsModule } from '../workflows.module';
import { SpinnerService } from '../../shell/spinner/spinner.service';

@Component({
    selector: 'app-content-renderer',
    templateUrl: './content-renderer.component.html',
    styleUrls: ['./content-renderer.component.scss']
})
export class ContentRendererComponent implements OnInit {

    @Input() content: string;
    @Input() anchors: app.models.WorkflowNodeAnchorModel[];
    @Output() selectNode: EventEmitter<number> = new EventEmitter<number>();;
    dynamicExtraModules = [WorkflowsModule]
    self: ContentRendererComponent;

    constructor(private elementRef: ElementRef, private spinnerService: SpinnerService) {
        this.self = this;
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["content"]) {
            // Clear previous content (otherwise it is appended)
            let htmlElement = <HTMLElement>this.elementRef.nativeElement;
            while (htmlElement.firstElementChild) {
                htmlElement.removeChild(htmlElement.firstElementChild);
            }
            this.spinnerService.start();
        }
       
    }

    finishTemplateLoading() {
        this.spinnerService.stop();
    }


    onSelectNode(id) {
        this.selectNode.emit(id);
    }
}



// WEBPACK FOOTER //
// ./src/app/workflows/content-renderer/content-renderer.component.ts